<template>
  <section class="max-w-md mx-auto">
    <div class="flex-row flex">
      <MembershipList class="w-1/2" />
      <div class="w-1/2 mx-4">
        <h2 v-html="`Action: <strong>${actionText}</strong>`" />
      </div>
    </div>
    <div class="flex justify-center my-6">
      <button
        type="button"
        class="btn-sm btn--link btn mr-6"
        @click="previousTab"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn-sm btn-success btn"
        @click="$emit('confirmed')"
        v-text="actionText"
      />
    </div>
  </section>
</template>

<script type="text/babel">
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'
import HasSelectedMemberships from 'Membership/Resources/assets/js/components/bulk-edit/mixins/HasSelectedMemberships'
import MembershipList from './MembershipList'

export default {
  name: 'ConfirmActivation',
  components: {
    MembershipList,
  },
  mixins: [
    TabNavigation,
    HasSelectedMemberships,
  ],
  props: {
    edits: {
      type: String,
      required: true,
    },
  },
  computed: {
    actionText() {
      return  this.edits === 'activate' ? 'Activate' : 'Deactivate'
    },
  },
}
</script>
